import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';

import Input from 'components/Input';

import { round6 as round } from 'utilities/math';
import { isRequiredNumber, isRequiredNumberGreaterThan, isRequiredIntegerGreaterThan, maxLength, isRequired } from 'utilities/validators.js';

import { minGroups, maxGroups } from './Component';
const isPositiveNumber = isRequiredNumberGreaterThan(0);
const isMoreThanOneInteger = isRequiredIntegerGreaterThan(1);
const isLessThan25Length = maxLength(25);


const getDefaultGroup = i => ({
  name: `Group ${i}`,
  [`sampleMeanGroup${i}`]: 0,
  [`stDeviationGroup${i}`]: 1,
  [`sampleSizeGroup${i}`]: 10
});

const ArrayGroup = props => {
  const { fields, numberOfGroups, isSummaryDataTab } = props;
  const [countOfGroup, setCountOfGroup] = useState(+numberOfGroups);
  const formatFn = value => value || value === 0 ? round(value) : '';

  useEffect(() => {
    let count = 1;
    if (numberOfGroups < minGroups || numberOfGroups > maxGroups) {
      return;
    }

    if (countOfGroup < +numberOfGroups) {
      count = countOfGroup + 1;

      while (count <= +numberOfGroups) {
        fields.push(getDefaultGroup(count));
        count += 1;
      }
    }

    if (countOfGroup > numberOfGroups) {
      count = countOfGroup;
      while (count >= +numberOfGroups) {
        fields.remove(count);
        count -= 1;
      }
    }

    setCountOfGroup(+numberOfGroups);

  }, [numberOfGroups]);


  return (
    <ul data-testid="arrayGroup">
      {fields.map((member, index) => (
        <li key={member}>
          <Field
            name={`${member}.name`}
            id={`name${index + 1}`}
            label={`Group ${index + 1} Name`}
            type="text"
            component={Input}
            validate={[isLessThan25Length, isRequired]}
            labelClassName="main-input__label font-900 font-14 colorInh"
            wrapperClassName="relative iconTop mb-15"
            disabled={!isSummaryDataTab}
          />
          {isSummaryDataTab && (
            <div className="flex space-between mb-15">
              <Field
                type="number"
                component={Input}
                name={`${member}.sampleMeanGroup${index + 1}`}
                id={`sampleMeanGroup${index + 1}`}
                label="Sample Mean"
                pattern="\d+"
                format={formatFn}
                validate={isRequiredNumber}
                wrapperClassName="relative width-32 iconTop two-lines"
                inputClassName="main-input__input"
                labelClassName="main-input__label width-70"
              />

              <Field
                type="number"
                component={Input}
                name={`${member}.stDeviationGroup${index + 1}`}
                id={`stDeviationGroup${index + 1}`}
                label="Sample St. Dev."
                pattern="\d+"
                min={1}
                format={formatFn}
                validate={isPositiveNumber}
                wrapperClassName="relative width-32 iconTop two-lines"
                inputClassName="main-input__input"
                labelClassName="main-input__label width-70"
              />

              <Field
                type="number"
                component={Input}
                name={`${member}.sampleSizeGroup${index + 1}`}
                id={`sampleSizeGroup${index + 1}`}
                label="Sample Size"
                pattern="\d+"
                min={2}
                format={formatFn}
                validate={isMoreThanOneInteger}
                wrapperClassName="relative width-32 iconTop two-lines"
                inputClassName="main-input__input"
                labelClassName="main-input__label width-70"
              />
            </div>
          )
          }
        </li>
      ))}
    </ul>
  );
};

ArrayGroup.propTypes = {
  numberOfGroups: PropTypes.string.isRequired,
  fields: PropTypes.any.isRequired,
  isSummaryDataTab: PropTypes.bool.isRequired
};

export default ArrayGroup;
